import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
    InsertChart as InsertChartIcon,
    LockReset as LockResetIcon,
    Logout as LogoutIcon,
    Menu as MenuIcon
} from '@mui/icons-material';
import { StateContextPropertyType, useStateContext } from "../reducers";
import { drawerWidth, headerHeight } from "../utils/Common";
import { useNavigate } from "react-router-dom";

function Navbar()
{
    const {menuState, setMenuState}: StateContextPropertyType = useStateContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    return (
        <AppBar
            position="fixed"
            sx={{
                width: { md: menuState?.showSidebar ? `calc(100vw - ${drawerWidth}px)` : "100vw" },
                ml: { md: `${drawerWidth}px` },
                height: headerHeight,
            }}
            className="bg-color-default"
        >
            <Toolbar
                sx={{
                    width: "100%",
                    display: "flex !important",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingX: "none !important",
                }}
            >
            {
                !isMobile &&
                <IconButton
                    color="inherit"
                    aria-label="Buka Menu"
                    edge="start"
                    onClick={() => {
                        setMenuState({...menuState, type: "toggle", showSidebar: !menuState?.showSidebar});
                    }}
                    sx={{
                        mr: 2
                    }}
                >
                    <MenuIcon />
                </IconButton>
            }
                <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                        flexGrow: 1,
                        textAlign: "left",
                    }}
                >
                    Booking Service
                </Typography>
            {
                !isMobile &&
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                    }}
                >
                    <IconButton
                        color="inherit"
                        aria-label="Dashboard"
                        edge="end"
                        onClick={() => navigate("/dashboard")}
                        sx={{ mr: 2 }}
                    >
                        <InsertChartIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        aria-label="Ubah Password"
                        edge="end"
                        onClick={() => navigate("/change-password")}
                        sx={{ mr: 2 }}
                    >
                        <LockResetIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        aria-label="Logout"
                        edge="end"
                        onClick={() => navigate("/logout")}
                        sx={{ mr: 2 }}
                    >
                        <LogoutIcon />
                    </IconButton>
                </Box>
            }
            </Toolbar>
        </AppBar>
    )
};

export default Navbar;
